<template>
    <multi-selector
        :available="available"
        :selected="selected"
        :disabled="disabled"
        available-title="Sensores disponíveis"
        selected-title="Sensores selecionados"
        @select="select"
        @deselect="deselect"
    />
</template>

<script>
import { mapState } from "vuex";
import MultiSelector from "@/components/MultiSelector";
import differenceBy from "@/utils/differenceBy";

export default {
    name: "SensorSelector",
    components: {
        MultiSelector
    },
    props: {
        selectedType: {
            type: Number,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selected: []
        };
    },
    computed: {
        ...mapState("common/sensors", ["sensors"]),
        available() {
            const currentList = this.sensors.filter(
                item => item.kind === this.selectedType
            );

            return differenceBy(currentList, this.selected, "id");
        }
    },
    watch: {
        selectedType() {
            this.selected = [];
        },
        selected(selected) {
            this.$emit("change-selected", selected);
        }
    },
    methods: {
        select(data) {
            const selected = this.selected.concat(data);

            selected.sort((a, b) => {
                if (a.name > b.name) {
                    return 1;
                }

                if (a.name < b.name) {
                    return -1;
                }

                return 0;
            });

            this.selected = selected;
        },
        deselect(data) {
            this.selected = differenceBy(this.selected, data, "id");
        }
    }
};
</script>
